import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Public Pages
import HomePage from "@/pages/public/HomePage";
import ExpertisePage from "@/pages/public/ExpertisePage";
import ProprietairesPage from "@/pages/public/ProprietairesPage";
import VoyageursPage from "@/pages/public/VoyageursPage";
import LogementDetailPage from "@/pages/public/LogementDetailPage";
import BlogPage from "@/pages/public/BlogPage";
import ArticlePage from "@/pages/public/ArticlePage";
import ContactPage from "@/pages/public/ContactPage";
import MentionsLegalesPage from "@/pages/public/MentionsLegalesPage";
import PolitiqueConfidentialitePage from "@/pages/public/PolitiqueConfidentialitePage";
import NotreMethodePage from "@/pages/public/NotreMethodePage";
import FaqPage from "@/pages/public/FaqPage";
import SousLocationPage from "@/pages/public/SousLocationPage";
import ConciergeriePage from "@/pages/public/ConciergeriePage";
import SimulateurPage from "@/pages/public/SimulateurPage";
import NotFoundPage from "@/pages/public/NotFoundPage";

// Admin Pages
import LoginPage from "@/pages/admin/LoginPage";
import DashboardPage from "@/pages/admin/DashboardPage";
import LogementsAdminPage from "@/pages/admin/LogementsAdminPage";
import ReservationsAdminPage from "@/pages/admin/ReservationsAdminPage";
import ProprietairesAdminPage from "@/pages/admin/ProprietairesAdminPage";
import LeadsAdminPage from "@/pages/admin/LeadsAdminPage";
import CalendrierPage from "@/pages/admin/CalendrierPage";
import ICalSyncPage from "@/pages/admin/ICalSyncPage";
import PrestationsPage from "@/pages/admin/PrestationsPage";
import IncidentsPage from "@/pages/admin/IncidentsPage";
import CMSPage from "@/pages/admin/CMSPage";
import RapportsPage from "@/pages/admin/RapportsPage";
import NewsletterAdminPage from "@/pages/admin/NewsletterAdminPage";

// Layout
import PublicLayout from "@/components/layout/PublicLayout";
import AdminLayout from "@/components/layout/AdminLayout";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/expertise" element={<ExpertisePage />} />
            <Route path="/proprietaires" element={<ProprietairesPage />} />
            <Route path="/voyageurs" element={<VoyageursPage />} />
            <Route path="/logement/:id" element={<LogementDetailPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<ArticlePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/notre-methode" element={<NotreMethodePage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/sous-location" element={<SousLocationPage />} />
            <Route path="/conciergerie-privee" element={<ConciergeriePage />} />
            <Route path="/simulateur" element={<SimulateurPage />} />
            <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin/login" element={<LoginPage />} />
          <Route element={<AdminLayout />}>
            <Route path="/admin" element={<DashboardPage />} />
            <Route path="/admin/logements" element={<LogementsAdminPage />} />
            <Route path="/admin/reservations" element={<ReservationsAdminPage />} />
            <Route path="/admin/proprietaires" element={<ProprietairesAdminPage />} />
            <Route path="/admin/leads" element={<LeadsAdminPage />} />
            <Route path="/admin/calendrier" element={<CalendrierPage />} />
            <Route path="/admin/ical-sync" element={<ICalSyncPage />} />
            <Route path="/admin/prestations" element={<PrestationsPage />} />
            <Route path="/admin/incidents" element={<IncidentsPage />} />
            <Route path="/admin/cms" element={<CMSPage />} />
            <Route path="/admin/rapports" element={<RapportsPage />} />
            <Route path="/admin/newsletter" element={<NewsletterAdminPage />} />
          </Route>
          <Route path="*" element={<PublicLayout />}>
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
